module.exports = __webpack_public_path__ + "img/tool1.569b7fe.png";